import { render, staticRenderFns } from "./historyItem.vue?vue&type=template&id=cdf6bec6&scoped=true&"
import script from "./historyItem.vue?vue&type=script&lang=js&"
export * from "./historyItem.vue?vue&type=script&lang=js&"
import style0 from "./historyItem.vue?vue&type=style&index=0&id=cdf6bec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf6bec6",
  null
  
)

export default component.exports